import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { DOCUMENTS_PER_PAGE, fetchAgreementDocuments } from '../services/agreementDocuments';
import { documentPollInterval } from '../utils/documentPolling';
import { agreementKeys } from './agreementKeys';

/** Page state is keyed by agreement id, so opening another agreement starts on page 1. */
export function useAgreementDocuments(id: string | undefined, enabled: boolean) {
    const [pageState, setPageState] = useState({ id, page: 1 });
    const page = pageState.id === id ? pageState.page : 1;
    const setPage = useCallback((next: number) => setPageState({ id, page: next }), [id]);

    const query = useQuery({
        queryKey: agreementKeys.documentsPage(id ?? '', page, DOCUMENTS_PER_PAGE),
        queryFn: () => fetchAgreementDocuments(id!, { page, perPage: DOCUMENTS_PER_PAGE }),
        enabled: enabled && !!id,
        refetchInterval: (current) => documentPollInterval(current.state.data?.data ?? [], Date.now()),
        placeholderData: (previousData, previousQuery) =>
            previousQuery?.queryKey[2] === (id ?? '') ? previousData : undefined,
    });

    return { query, page, setPage };
}
